import type { AssessmentDetail } from '@/types/accessor/api/emergencyInspectionResult/assessmentDetails/assessmentDetailObject'
import type { ConstructionType } from '@/types/accessor/api/emergencyInspectionResult/assessmentInfo/constructionType'
import type { ArgUpsertItemInspectionResult } from '@/types/accessor/api/emergencyInspectionResult/emergencyInspectionResult'
import MiiaFwConfig from '@/configs/config'
import { useDisasterStore } from '../disasterStore'
import { getUserIdToStorage } from '@/modules/miiaFw/MiiaFwCognito'
import type { EmergencyAssessment } from '@/types/accessor/api/emergencyInspectionResult/emergencyAssessment/emergencyAssessment'
import type { AssessmentInfo } from '@/types/accessor/api/emergencyInspectionResult/assessmentInfo/assessmentInfo'
import type { Building } from '@/types/accessor/api/emergencyInspectionResult/building/building'
import type { BuildingOverview } from '@/types/accessor/api/emergencyInspectionResult/buildingOverview'

/** APIリクエスト（upsert）のリクエストパラメータ作成関数のインターフェース */
interface BuildInspectionResultUpsertParamArgs<T extends ConstructionType> {
  assessmentDetail: AssessmentDetail<T>
  assessmentId: string
  emergencyAssessment: EmergencyAssessment
  assessmentInfo: AssessmentInfo
  building: Building
  buildingOverview: BuildingOverview
}

/**
 * APIリクエスト（upsert）のリクエストパラメータを作成する
 * @param params リクエストパラメータの作成元データ
 * @returns APIリクエスト（upsert）のリクエストパラメータ
 */
export const buildInspectionResultUpsertParam = <T extends ConstructionType>(
  params: BuildInspectionResultUpsertParamArgs<T>
): ArgUpsertItemInspectionResult | null => {
  const {
    assessmentDetail,
    assessmentId,
    emergencyAssessment,
    assessmentInfo,
    building,
    buildingOverview
  } = params

  const userId = getUserIdToStorage()
  const disasterStore = useDisasterStore()

  if (disasterStore.disaster == null || userId == null || assessmentDetail == null) return null
  return {
    needRecords: false,
    system: MiiaFwConfig.config.sysId,
    govCode: disasterStore.disaster.govCode,
    disasterId: disasterStore.disaster.disasterId,
    // オフライン→オンライン時に一括更新を想定してリスト型になっているが、調査完了時の更新は1調査のみの更新なので、1件のみでパラメータ作成
    inspectionResultList: [
      {
        assessmentId: assessmentId,
        userId: userId,
        emergencyAssessment: emergencyAssessment,
        assessmentInfo: assessmentInfo,
        building: building,
        buildingOverview: buildingOverview,
        assessmentDetail: assessmentDetail
      }
    ]
  }
}
